import type { ComponentType } from 'react';
import {
  SignInPageBlueprint,
  type SignInPageProps,
} from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { autheliaAuthApiRef } from '@internal/plugin-waadoo-core';
import { WaadooSignInPage } from './WaadooSignInPage';

const autheliaProvider = {
  id: 'authelia-oidc-provider',
  title: 'Compte Waadoo',
  message:
    'Connectez-vous avec votre compte Waadoo (authentification unique Authelia).',
  apiRef: autheliaAuthApiRef,
  enableExperimentalRedirectFlow: true,
};

/**
 * Local development only: the stock core-components page with a guest option
 * next to Authelia, where running Authelia is impractical. Left on the core
 * page on purpose — its guest provider handles the legacy guest token and the
 * provider remembered in localStorage, which is not worth copying for a page
 * no deployed environment serves.
 */
const DevelopmentSignInPage = (props: SignInPageProps) => (
  <SignInPage {...props} providers={['guest', autheliaProvider]} />
);

// Guest sign-in is offered only in local development. Bundling for production
// sets NODE_ENV=production, so this condition folds to `false` and both
// DevelopmentSignInPage and autheliaProvider, referenced from nowhere else,
// are dropped from the deployed bundle: the sign-in page stays Authelia-only.
// The matching backend module is gated the same way in
// packages/backend/src/index.ts.
const isDevelopment = process.env.NODE_ENV === 'development';

/** The sign-in page of this build. Exported for its test only. */
export const SelectedSignInPage: ComponentType<SignInPageProps> = isDevelopment
  ? DevelopmentSignInPage
  : WaadooSignInPage;

export const customSignInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => SelectedSignInPage,
  },
});
